<template>
  <b-modal :active="active" :canCancel="false" has-modal-card>
    <form class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title" v-t="'title'" />
      </header>

      <section class="modal-card-body">
        <products-form :product.sync="product" :errors="errors" />
      </section>

      <footer class="modal-card-foot">
        <button class="button" type="button" @click="close()">
          <b-icon icon="times" /><span v-t="'buttons.cancel'" />
        </button>

        <button class="button is-danger" type="submit" @click.prevent="save()">
          <b-icon icon="save" /><span v-t="'buttons.save'" />
        </button>
      </footer>
    </form>
  </b-modal>
</template>

<script>
import API from '@/api'
import ProductsForm from './ProductsForm'

export default {
  name: 'ProductsNew',
  props: { active: Boolean },
  components: { ProductsForm },
  data () {
    return {
      errors: {},
      product: {
        name: '',
        logo: null
      }
    }
  },
  methods: {
    save () {
      let formData = new FormData()

      formData.append('name', this.product.name)

      if (this.product.logo !== null && this.product.logo instanceof File) {
        formData.append('logo', this.product.logo)
      }

      API.products.store(formData, this.saveCallback, this.errorCallback)
    },
    close () {
      this.errors = {}
      this.product = {}
      this.$router.push({ name: 'products' })
    },
    saveCallback () {
      this.$snotify.success(this.$t('alerts.success'), this.$t('alert.title.success'))
      this.close()
    },
    errorCallback (err) {
      this.$snotify.error(this.$t('alerts.error'), this.$t('alert.title.error'))
      if (err.response) {
        this.errors = err.response.data.errors
      }
    }
  }
}
</script>

<i18n src="@/lang/locales.json"></i18n>
<i18n>
{
  "en-US": {
    "title": "New Product",
    "buttons": {
      "cancel": "Cancel",
      "save": "Save"
    },
    "alerts": {
      "success": "Product created successfully!",
      "error": "An error occurred when creating the product!"
    }
  },
  "pt-BR": {
    "title": "Novo Produto",
    "buttons": {
      "cancel": "Cancelar",
      "save": "Salvar"
    },
    "alerts": {
      "success": "Produto cadastrado com sucesso!",
      "error": "Erro ao cadastrar o produto!"
    }
  }
}
</i18n>
